import { useEffect } from "react";


function WorkbookVideo({ video }) {

    useEffect(() => {
        let videoModal = document.getElementById('videoModal')
        if (videoModal) {
            videoModal.addEventListener('hidden.bs.modal', function () {
                document.getElementById('ytplayer').setAttribute('src', '');
            })
        }
    }, [])

    return (
        <div className="modal fade" id="videoModal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content border border-2 border-blue p-2 rounded-4">
                    <div className="modal-header border-0 ">
                        <h3 className="fw-bold text-blue">Video</h3>
                    </div>
                    <div className="modal-body">
                        <div className="col-sm-12">
                            <iframe width="100%" height="400px" id="ytplayer" title="Video Solution" src={`https://www.youtube.com/embed/${video?.substring(video?.lastIndexOf("/") + 1)}`}></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default WorkbookVideo
